import React from 'react';

import Uploader from './Uploader';
import './Subs.css'
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { downloadFromUrl } from './helpers';

class Subs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      isUploaded: false
    }
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
  }

  closeModal = () => {
    this.setState({ isModalOpen: false });
  }

  exportFile = async (selection) => {
    const { data } = await axios.get('/api/substitution_rules/export');

    downloadFromUrl(data.url);
  }

  // TODO: DRY with Inventory
  render() {
    return (
      <div className="subs-container">
        <div className="subs-title">Substitutions</div>
        <div className="subs-section">
          <Button className="subs-button" variant="info" onClick={this.exportFile}>Export</Button>
          <Button variant="primary" onClick={this.openModal}>Import</Button>
        </div>

        { this.state.isModalOpen &&
          <div className="popup" id="popup-dialog">
            <div className="popup-content" id="content">
              <div className="popup-content-header">
                <Button variant="danger" onClick={this.closeModal}>X</Button>
              </div>
              <div className="popup-content-container">
                <Uploader uploadEndpoint="/api/substitution_rules/import" format="xlsx" placeholder="Import Subs .xlsx file"/>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default Subs;
